/**
 * @file Hook de sync du brouillon de réservation abandonné pour le widget embarqué (auth par clé API).
 * @module packages.common.hooks.api.widgets.restaurants.ReservationDraft
 *
 * Câblé sur `axiosWidget` et l'endpoint `externalApi.restaurant.reservation.draft`,
 * la clé API étant injectée via `withApiKey`. Le hook public équivalent vit dans
 * `api/public/restaurants/ReservationDraft`.
 *
 * Appel fire-and-forget : l'appelant (useReservationDraftSync) avale les erreurs,
 * le hook se contente de les propager sans state de loading/erreur.
 */

import {useCallback} from 'react';
import axiosWidgetInstance, {withApiKey, widgetEndpoints} from 'packages/common/utils/axiosWidget';

/**
 * Hook fournissant l'upsert impératif du brouillon d'un parcours non finalisé.
 *
 * @return {Function} `syncReservationDraft(companyId, payload, apiKey)` —
 *   résout la réponse JSON brute de l'endpoint `draft`
 */
export const useExternalSyncReservationDraft = () => {
  return useCallback(async (companyId, payload, apiKey) => {
    const response = await axiosWidgetInstance.post(
        widgetEndpoints.externalApi.restaurant.reservation.draft(companyId),
        payload,
        withApiKey(apiKey),
    );
    return response.data;
  }, []);
};
